export default {
  state: {
    toasts: []
  },
  mutations: {
    addToast(state, toast) {
      state.toasts.unshift(toast);
    },
    removeToast(state, toast) {
      state.toasts.splice(state.toasts.indexOf(toast), 1);
    }
  },
  actions: {
    addToast({ commit }, toast) {
      commit("addToast", toast);
      setTimeout(() => {
        commit("removeToast", toast);
      }, 5000);
    },
    addSuccessToast({ dispatch }, toastText) {
      dispatch("addToast", { type: "success", text: toastText });
    },
    addErrorToast({ dispatch }, toastText) {
      dispatch("addToast", { type: "error", text: toastText });
    },
    addInfoToast({ dispatch }, toastText) {
      dispatch("addToast", { type: "info", text: toastText });
    }
  }
};
